import { combineReducers } from "redux";
import chatReducer from "./chatReducer";
import messagePaneReducer from "./messagePaneReducer";
import amazonConnectReducer from "./amazonConnectReducer";
import errorReducer from "./errorReducer";

export default combineReducers({
  //list reducer here for it to show up in store
  chatReducer: chatReducer,
  messagePaneReducer: messagePaneReducer,
  amazonConnectReducer: amazonConnectReducer,
  errorReducer: errorReducer,
});
